import { useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator,
  TouchableOpacity
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { useTranslation } from 'react-i18next'
import Card from '../../shared/card/Card'
import CardSeparator from '../../shared/card/CardSeparator'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import ModalDrawer from '../../shared/modal/ModalDrawer'
import { Ionicons } from '@expo/vector-icons'
import Toast from 'react-native-toast-message'
import { useStoreStore } from '../../../stores/storeInfo'
import AsyncStorage from '@react-native-async-storage/async-storage'

type response = {
  success: boolean
  message: string
  error: string
}

const intialValues = {
  filingStatus: null,
  exemptFromFederalTax: null,
  higherWithholdingRate: null,
  underagechildren: '',
  otherdependents: '',
  dependents: '',
  otherIncome: '',
  deductions: '',
  extraWithholdingPerPay: '',
  // exemptFromWithholding: ""
}

const W4InformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    essUserOnBoardingFormKey,
    essUserOnBoardingKey,
    mode
  } = params
  const { t } = useTranslation()
  const { postW4Data, loading, getmodetails } = useFormsStore()
  const { initializeData } = useInitializeStore()
  const { personalData } = usePersonalStore()



  const w4schema = yup.object({
    filingStatus: yup
      .mixed()
      .nullable()
      .required(t('Filing Status is a required field')),
    exemptFromFederalTax: yup
      .mixed()
      .nullable()
      .required(t('Exempt from Federal Tax is a required field')),
    higherWithholdingRate: yup
      .mixed()
      .nullable()
      .required(t('Higher Withholding Rate is a required field')),
    underagechildren: yup
      .number()
      .typeError(t('Please enter numeric values'))
      .required(t(' Children Age Under 17 is a required field')),
    otherdependents: yup
      .number()
      .typeError(t('Please enter numeric values'))
      .required(t('Other Dependents is a required field')),
    // dependents: yup
    //   .number()
    //   .typeError(t('Please enter numeric values'))
    //   .required(t('Dependents is a required field')),
    otherIncome: yup
      .number()
      .typeError(t('Please enter numeric values'))
      .required(t('Other Income is a required field')),
    deductions: yup
      .number()
      .typeError(t('Please enter numeric values'))
      .required(t('Deductions is a required field')),
    extraWithholdingPerPay: yup
      .number()
      .typeError(t('Please enter numeric values')),
    // exemptFromWithholding: yup.mixed()
    // .nullable()
    // .required(t('Exempt from withholding is a required field')),
  })

  const getLanguage = async () => {
    try {
      const language = await AsyncStorage.getItem('selectedLanguage') || 'ENG';
      if (language === 'SPA') {
        return 'Spanish';
      } else {
        return 'English';
      }
    } catch (error) {
      console.error('Error retrieving selected language:', error);
      return 'English';
    }
  }

  const options3 = [
    { key: 1, value: t('Single / Filing Separate') },
    { key: 2, value: t('Married / Filing Jointly') },
    { key: 3, value: t('Head of Household') }
  ]
  const options1 = [
    { key: 1, value: t('No') },
    { key: 2, value: t('Yes') }
  ]

  const options2 = [
    { key: 1, value: t('No') },
    { key: 2, value: t('Yes') }
  ]
  const [modalVisible1, setModalVisible1] = useState(false)
  const [modalVisible2, setModalVisible2] = useState(false)
  const [modalVisible3, setModalVisible3] = useState(false)
  const [modalVisible4, setModalVisible4] = useState(false)
  const [modalVisible5, setModalVisible5] = useState(false)
  const [modalVisible6, setModalVisible6] = useState(false)
  const [modalVisible7, setModalVisible7] = useState(false)
  const [modalVisible8, setModalVisible8] = useState(false)
  const [modalVisible9, setModalVisible9] = useState(false)
  // const [modalVisible10, setModalVisible10] = useState(false)

  const bodyHtml = t('bodyHtml')
  const bodyHtml2 = t('bodyHtml2')
  const bodyHtml3 = t('bodyHtml3')
  const bodyHtml4 = t('bodyHtml4')
  const bodyHtml5 = t('bodyHtml5')
  const bodyHtml6 = t('bodyHtml6')
  const bodyHtml7 = t('bodyHtml7')
  const bodyHtml8 = t('bodyHtml8')
  const bodyHtml9 = t('bodyHtml9')
  // const bodyHtml10 = t('bodyHtml10')
  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel={t("Forms")}
            navScreen="OnboardingForms"
            title={t('W-4 Information')}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={w4schema}
          onSubmit={async (values, actions) => {
            const selectedLanguage = await getLanguage()
            const calculatedUnderAge = values?.underagechildren ? Number(values.underagechildren) * 2200 : ""
            const calculatedOtherDependents = values?.otherdependents ? Number(values.otherdependents) * 500 : ""
            const calculatedDependents = (values?.underagechildren ? Number(values.underagechildren) * 2200 : 0) +
              (values?.otherdependents ? Number(values.otherdependents) * 500 : 0)

            const data = {
              filingStatus: values?.filingStatus,
              exemptFromFederalTax: values?.exemptFromFederalTax,
              higherWithholdingRate: values?.higherWithholdingRate,
              munderAge: calculatedUnderAge,
              motherDependents: calculatedOtherDependents,
              dependents: calculatedDependents,
              otherIncome: Number(values?.otherIncome),
              deductions: Number(values?.deductions),
              extraWithholdingPerPay:values?.extraWithholdingPerPay? Number(values?.extraWithholdingPerPay):null,
              essUserKey: initializeData.userkey,
              entityId: personalData.entityId,
              FormKey: essUserOnBoardingFormKey,
              essObKey: userId,
              completeOnline: mode === 'upload' ? false : true,
              Language: selectedLanguage
            }

            const w4Data: any = await postW4Data(data)
            if (w4Data?.success) {
              if (mode === 'upload') {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: t(w4Data?.message),
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              } else {
                navigation.navigate('W4preview', {
                  essUserOnBoardingFormKey,
                  filingStatus: values.filingStatus,
                  exemptFromFederalTax: values.exemptFromFederalTax,
                  higherWithholdingRate: values.higherWithholdingRate,
                  munderAge: calculatedUnderAge,
                  motherDependents: calculatedOtherDependents,
                  dependents: calculatedDependents,
                  otherIncome: values.otherIncome,
                  deductions: values.deductions,
                  extraWithholdingPerPay: values.extraWithholdingPerPay,
                  completeOnline: mode === 'upload' ? false : true,
                  values,
                  essUserOnBoardingKey
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: w4Data?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.vCenterItems,
                    globalStyles.hBetweenItems
                  ]}
                >
                  <Text
                    style={[
                      globalStyles.text,
                      globalStyles.fwBold,
                      globalStyles.fs18,
                      globalStyles.blackTextColor
                    ]}

                  >
                    {t('Maintain Employee Federal W-4')}
                  </Text>
                  <Text
                    style={[
                      globalStyles.text,
                      globalStyles.fs14,
                      globalStyles.grayTextColor
                    ]}
                  >
                    *
                  </Text>
                </View>
                <CardSeparator light={true} />
                <View>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{
                      justifyContent: 'flex-start', flexDirection: 'row', width: '48%', alignSelf: 'center'
                    }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Filing Status')}
                      </Text>
                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible1(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"
                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible1}
                        headerText={t('Filing Status')}
                        bodyText={bodyHtml}
                        position="center" // Adjust as needed: "top", "bottom"
                        screen="full" // Adjust as needed: "dropdown"
                        offCanvas={true} // Adjust as needed: false
                        flatTop={true} // Example prop, adjust as needed
                        flatBottom={true} // Example prop, adjust as needed
                        onClose={() => setModalVisible1(false)} // Pass the function to close the modal
                      /></View>

                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={t('Filing Status')}
                        options={options3}
                        selectedOption={mapSelectValue(
                          options3,
                          props.values.filingStatus
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('filingStatus', option - 1)
                        }}
                        textColor="primary"
                      />
                      {props.touched.filingStatus &&
                        props.errors.filingStatus && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.filingStatus as string}
                          </Text>
                        )}
                    </View>
                  </View>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >

                    <View style={{
                      justifyContent: 'flex-start', flexDirection: 'row', alignSelf: 'center', width: '48%'
                    }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Exempt from Federal Tax')}
                      </Text>
                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible2(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible2}
                        headerText={t('Exempt from Federal Tax')}
                        bodyText={bodyHtml2}
                        position="center" // Adjust as needed: "top", "bottom"
                        screen="full" // Adjust as needed: "dropdown"
                        offCanvas={true} // Adjust as needed: false
                        flatTop={true} // Example prop, adjust as needed
                        flatBottom={true} // Example prop, adjust as needed
                        onClose={() => setModalVisible2(false)} // Pass the function to close the modal
                      /></View>


                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={t("Exempt from Federal Tax")}
                        options={options1}
                        selectedOption={mapSelectValue(
                          options1,
                          props.values.exemptFromFederalTax
                        )}
                        onSelect={(option: any) => {
                          const val = option - 1
                          props.setFieldValue(
                            'exemptFromFederalTax',
                            val
                          )
                          if (val === 1) {
                            props.setFieldValue('extraWithholdingPerPay', '')
                          }
                        }}
                        textColor="primary"
                      />
                      {props.touched.exemptFromFederalTax &&
                        props.errors.exemptFromFederalTax && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.exemptFromFederalTax as string}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'flex-start', flexDirection: 'row', alignSelf: 'center', width: '48%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Higher Withholding Rate')}
                      </Text>
                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible3(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible3}
                        headerText={t('Higher Withholding Rate')}
                        bodyText={bodyHtml3}
                        position="center"
                        screen="full"
                        offCanvas={true}
                        flatTop={true}
                        flatBottom={true}
                        onClose={() => setModalVisible3(false)}
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={t("Higher Withholding Rate")}
                        options={options2}
                        selectedOption={mapSelectValue(
                          options2,
                          props.values.higherWithholdingRate
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue(
                            'higherWithholdingRate',
                            option - 1
                          )
                        }}
                        textColor="primary"
                      />
                      {props.touched.higherWithholdingRate &&
                        props.errors.higherWithholdingRate && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.higherWithholdingRate as string}
                          </Text>
                        )}
                    </View>
                  </View>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'flex-start', flexDirection: 'row', width: '29%', alignSelf: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {/* {t('Children Under Age 17 (Multiply by $2200)')} {'($)'} */}
                        {t('Number of children under 17')}
                      </Text>

                      <TouchableOpacity style={{ marginTop: 1 }} onPress={() => setModalVisible8(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible8}
                        headerText={t('Number of children under 17')}
                        bodyText={bodyHtml8}
                        position="center"
                        screen="full"
                        offCanvas={true}
                        flatTop={true}
                        flatBottom={true}
                        onClose={() => setModalVisible8(false)}
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.underagechildren}
                        //onChangeText={props.handleChange('underagechildren')}
                        keyboardType="numeric" // Set the keyboard type to numeric
                        onChangeText={(text) => {
                          // Check if the entered value is a positive number
                          if (text === '' || /^\d+$/.test(text)) {
                            // Update the state only if it's a positive number
                            props.handleChange('underagechildren')(text)
                            // props.handleChange('dependents')(String(Number(text) + Number(props.values.otherdependents)))
                          }
                        }}
                      />
                      {props.touched.underagechildren && props.errors.underagechildren && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.underagechildren}
                        </Text>
                      )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'flex-start', flexDirection: 'row', width: '29%', alignSelf: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {/* {t('Other Dependents (Multiply by $500)')}{'($)'} */}
                        {t('Number of other dependents')}
                      </Text>

                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible9(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible9}
                        headerText={t('Number of other dependents')}
                        bodyText={bodyHtml9}
                        position="center"
                        screen="full"
                        offCanvas={true}
                        flatTop={true}
                        flatBottom={true}
                        onClose={() => setModalVisible9(false)}
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.otherdependents}
                        //onChangeText={props.handleChange('otherdependents')}
                        keyboardType="numeric" // Set the keyboard type to numeric
                        onChangeText={(text) => {
                          // Check if the entered value is a positive number
                          if (text === '' || /^\d+$/.test(text)) {
                            // Update the state only if it's a positive number
                            props.handleChange('otherdependents')(text)
                            // props.handleChange('dependents')(String(Number(text) + Number(props.values.underagechildren)))
                          }
                        }}
                      />
                      {props.touched.otherdependents && props.errors.otherdependents && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.otherdependents}
                        </Text>
                      )}
                    </View>
                  </View>
                  {/* <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'flex-start', flexDirection: 'row', width: '29%', alignSelf: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Total Dependents')} {'($)'}
                      </Text>

                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible4(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible4}
                        headerText={t('Total Dependents')}
                        bodyText={bodyHtml4}
                        position="center"
                        screen="full"
                        offCanvas={true}
                        flatTop={true}
                        flatBottom={true}
                        onClose={() => setModalVisible4(false)}
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.dependents}
                        //onChangeText={props.handleChange('dependents')}
                        keyboardType="numeric" // Set the keyboard type to numeric
                        onChangeText={(text) => {
                          // Check if the entered value is a positive number
                          if (text === '' || /^\d+$/.test(text)) {
                            // Update the state only if it's a positive number
                            props.handleChange('dependents')(text)
                          }
                        }}
                      />
                      {props.touched.dependents && props.errors.dependents && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.dependents}
                        </Text>
                      )}
                    </View>
                  </View> */}

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{
                      justifyContent: 'flex-start',
                      flexDirection: 'row',
                      alignSelf: 'center', width: '31.5%'
                    }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Other Income')} {'($)'}
                      </Text>
                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible5(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible5}
                        headerText={t('Other Income')}
                        bodyText={bodyHtml5}
                        position="center" // Adjust as needed: "top", "bottom"
                        screen="full" // Adjust as needed: "dropdown"
                        offCanvas={true} // Adjust as needed: false
                        flatTop={true} // Example prop, adjust as needed
                        flatBottom={true} // Example prop, adjust as needed
                        onClose={() => setModalVisible5(false)} // Pass the function to close the modal
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.otherIncome}
                        //onChangeText={props.handleChange('otherIncome')}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('otherIncome')(text)
                          }
                        }}
                      />
                      {props.touched.otherIncome &&
                        props.errors.otherIncome && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.otherIncome}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'flex-start', flexDirection: 'row', alignSelf: 'center', width: '27%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Deductions')} {'($)'}
                      </Text>
                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible6(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible6}
                        headerText={t('Deductions')}
                        bodyText={bodyHtml6}
                        position="center" // Adjust as needed: "top", "bottom"
                        screen="full" // Adjust as needed: "dropdown"
                        offCanvas={true} // Adjust as needed: false
                        flatTop={true} // Example prop, adjust as needed
                        flatBottom={true} // Example prop, adjust as needed
                        onClose={() => setModalVisible6(false)} // Pass the function to close the modal
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.deductions}
                        //onChangeText={props.handleChange('deductions')}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('deductions')(text)
                          }
                        }}
                      />
                      {props.touched.deductions && props.errors.deductions && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.deductions}
                        </Text>
                      )}
                    </View>
                  </View>
                  {Number(props.values.exemptFromFederalTax) !== 1 && (
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'flex-start', flexDirection: 'row', alignSelf: 'center' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {t('Extra withholding Per Pay')} {'($)'}
                        </Text>
                        <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible7(true)}>
                          <Ionicons
                            name="information-circle"
                            size={16}
                            color="black"

                          />
                        </TouchableOpacity>

                        <ModalDrawer
                          visible={modalVisible7}
                          headerText={t('Extra withholding Per Pay')}
                          bodyText={bodyHtml7}
                          position="center" // Adjust as needed: "top", "bottom"
                          screen="full" // Adjust as needed: "dropdown"
                          offCanvas={true} // Adjust as needed: false
                          flatTop={true} // Example prop, adjust as needed
                          flatBottom={true} // Example prop, adjust as needed
                          onClose={() => setModalVisible7(false)} // Pass the function to close the modal
                        />
                      </View>
                      <View style={{ width: '48%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.extraWithholdingPerPay}
                          // onChangeText={props.handleChange(
                          //   'extraWithholdingPerPay'
                          // )}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('extraWithholdingPerPay')(text)
                            }
                          }}
                        />
                        {props.touched.extraWithholdingPerPay &&
                          props.errors.extraWithholdingPerPay && (
                            <Text style={[globalStyles.dangerAlert]}>
                              {props.errors.extraWithholdingPerPay}
                            </Text>
                          )}
                      </View>
                    </View>
                  )}



                  {/* <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'flex-start', flexDirection: 'row', alignSelf: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {t('Exempt from withholding')}
                      </Text>
                      <TouchableOpacity style={{ marginTop: 2 }} onPress={() => setModalVisible10(true)}>
                        <Ionicons
                          name="information-circle"
                          size={16}
                          color="black"

                        />
                      </TouchableOpacity>

                      <ModalDrawer
                        visible={modalVisible10}
                        headerText={t('Exempt from withholding')}
                        bodyText={bodyHtml10}
                        position="center" // Adjust as needed: "top", "bottom"
                        screen="full" // Adjust as needed: "dropdown"
                        offCanvas={true} // Adjust as needed: false
                        flatTop={true} // Example prop, adjust as needed
                        flatBottom={true} // Example prop, adjust as needed
                        onClose={() => setModalVisible10(false)} // Pass the function to close the modal
                      />
                    </View>
                    <View style={{ width: '48%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={t("Exempt from withholding")}
                        options={options1}
                        selectedOption={mapSelectValue(
                          options1,
                          props.values.exemptFromWithholding
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue(
                            'exemptFromWithholding',
                            option - 1
                          )
                        }}
                        textColor="primary"
                      />
                      {props.touched.exemptFromWithholding &&
                        props.errors.exemptFromWithholding && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.exemptFromWithholding as string}
                          </Text>
                        )}
                    </View>
                  </View> */}
                </View>
              </Card>
              {loading ? (
                <ActivityIndicator />
              ) : (
                <View style={{ margin: 10 }}>
                  <CustomButton
                    text={mode === 'upload' ? t('submitinfo') : t('next')}
                    onPress={props.handleSubmit}
                  />
                </View>
              )}
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default W4InformationForm
